import React from 'react';
import PropTypes from 'prop-types';
import CopyToClipboard from 'components/button/CopyToClipboard';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ActivateIcon } from 'assets/materialIcons/materialIcons';

const styles = {
    description: {
        display: 'block',
        fontStyle: 'italic',
        padding: '15px',
        margin: '0 0 25px 0',
        color: theme.palette.yukonGold,
        backgroundColor: theme.palette.blond,
        borderRadius: '2px',
    },
    data: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: theme.palette.black,
        border: `1px solid ${ theme.palette.silver }`,
        borderRadius: '2px',
    },
    token: {
        overflow: 'hidden',
        padding: '0 0 0 10px',
    },
};

class ApiKeysCreateModal extends React.Component {
    constructor() {
        super();

        this.state = {
            openModal: true,
        };
    }

    handleDialogOpen = () => {
        this.setState({
            dialog: true,
        });
    };

    handleDialogClose = () => {
        this.setState({
            dialog: false,
        });
    };

    handleDialogSubmit = () => {
        const {
            handleSubmit,
        } = this.props;

        handleSubmit();

        this.handleDialogClose();
    };

    render() {
        const {
            data,
            translate,
        } = this.props;

        const {
            openModal,
        } = this.state;

        const actions = [
            <RaisedButton
                icon={ <ActivateIcon /> }
                key='submit'
                label={ translate('actions.ok') }
                onTouchTap={ () => {
                    return this.handleDialogSubmit();
                } }
                primary
            />,
        ];

        return (
            <Dialog
                actions={ actions }
                actionsContainerStyle={ { padding: '0 24px 24px' } }
                contentStyle={ { maxWidth: '600px' } }
                modal={ true }
                overlayStyle={ {
                    backgroundColor: 'rgba(237, 236, 236, 0.6)',
                } }
                onRequestClose={ this.handleDialogClose }
                open={ openModal }
                title={ translate('resources.api-keys.modal.title', { name: data.name }) }
            >
                <div style={ styles.description } dangerouslySetInnerHTML={ { __html: translate('resources.api-keys.modal.description') } }></div>

                <div style={ styles.data }>
                    <div style={ styles.token }>
                        { data.token }
                    </div>

                    <div style={ styles.button }>
                        <CopyToClipboard string={ data.token } />
                    </div>
                </div>
            </Dialog>
        );
    }
}

ApiKeysCreateModal.propTypes = {
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ApiKeysCreateModal);



// WEBPACK FOOTER //
// ./src/pages/api-keys/create/ApiKeysCreateModalSuccess.js